module.exports = __webpack_public_path__ + "static/media/n15.380e6397.jpg";